export const findCategoryById = <T>(
  categories: T[],
  targetId: unknown
): T | undefined => {
  if (!categories?.length) return undefined;
  const initialValue: T | undefined = undefined;

  return categories.reduce((foundItem, category) => {
    if (foundItem) return foundItem;

    if (String(category.id) === String(targetId)) return category;

    const foundChild = category.children?.find(
      child => String(child.id) === String(targetId)
    );

    if (foundChild) return foundChild;

    return foundItem;
  }, initialValue);
};
